import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { color } from '../../../app/theme';

const useStyles = makeStyles(
  () => ({
    root: {
      margin: '0 0 12px 0',
      backgroundColor: color.$8,
      backgroundSize: 'cover',
      borderRadius: 16,
      position: 'relative',
      '&::after': {
        display: 'block',
        content: '""',
        paddingBottom: '100%',
      },
    },
    action: {
      position: 'absolute',
    },
  }),
  { name: 'ImagemapPreview' },
);
const screenSize = 336;
const scale = screenSize / 320;

function ImagemapPreview({ message }) {
  const classes = useStyles();
  const { size } = message?.data?.elements[0];
  const maxHeight = size.height * (screenSize / size.width);
  const renderActionBlock = () => {
    return message?.data?.elements[0]?.buttons.map((btn, index) => {
      const { height, width, x, y, type, data } = btn;

      if (type === 'url') {
        return (
          <a
            key={`ImageMapActionBlock-${index}`}
            className={classes.action}
            href={data}
            rel="noopener noreferrer"
            aria-label="message link"
            style={{
              height: scale * height,
              width: scale * width,
              top: scale * y,
              left: scale * x,
            }}
            target="_blank"
          >
            <i className="fa fa-phone" aria-hidden="true" />
          </a>
        );
      }
      return null;
    });
  };

  return (
    <div
      className={classes.root}
      style={{
        backgroundImage: `url(${message?.data?.elements[0].imageUrl})`,
        width: screenSize,
        height: maxHeight,
      }}
    >
      {renderActionBlock()}
    </div>
  );
}

ImagemapPreview.propTypes = {
  message: PropTypes.shape({}).isRequired,
};

export default ImagemapPreview;
